<template>
  <v-container fluid class="pa-0">
    <v-card class="mr-3 ml-3 mb-3 pa-3">
      <v-card-title>
        <span class="headline">Редактирование Лицензии № {{licenseId}}</span>
        <v-spacer></v-spacer>
        <v-btn color="warning" text @click="back">Назад</v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="isValid">
          <v-row>
            <v-col cols="12" md="5">
              <v-text-field
                label="Дилер"
                v-model="license.dealerName"
                :rules="[notEmptyRule]"
                readonly
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                label="Модуль ПО"
                v-model="license.moduleName"
                :rules="[notEmptyRule]"
                readonly
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="Количество"
                v-model="license.count"
                readonly
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                label="Объект"
                v-model="formattedObject"
                :rules="[notEmptyRule]"
                readonly
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="7">
              <v-card>
                <v-card-title
                  >Управление датой окончания<span
                    class="red--text ml-1"
                    v-if="license.isSosActivated"
                    >(SOS активирован)</span
                  ></v-card-title
                >
                <v-card-text>
                  <v-text-field
                    v-model="masterExpiresFormatted"
                    label="Мастер-лицензия действует включительно до"
                    prepend-icon="mdi-calendar"
                    readonly
                  ></v-text-field>

                  <div class="d-flex justify-space-around flex-wrap">
                    <v-btn class="mb-4" color="green" dark @click="addMonths(1)"
                      >+30 дней
                    </v-btn>
                    <v-btn
                      class="mb-4"
                      color="primary darken-2"
                      dark
                      @click="setMaxDate()"
                      >max дата
                    </v-btn>
                    <v-btn
                      class="mb-4"
                      color="red darken-2"
                      @click="sosSendDialog = true"
                      :dark="!license.isSosActivated"
                      :disabled="license.isSosActivated"
                      >SOS
                    </v-btn>
                    <v-btn
                      class="mb-4"
                      color="red lighten-2"
                      dark
                      @click="addDays(-1)"
                      >-1 день
                    </v-btn>
                  </div>

                  <v-menu
                    ref="menu1"
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="license.licExpires"
                        label="Лицензия действует включительно до"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        @blur="date = parseDate(license.licExpires)"
                        v-on="on"
                        readonly
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date"
                      no-title
                      @input="dateMenu = false"
                      :first-day-of-week="1"
                      locale="ru-RU"
                      :max="parseDate(masterExpiresFormatted)"
                    ></v-date-picker>
                  </v-menu>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="5" v-if="license.features.length > 0">
              <v-card>
                <v-card-title class="pb-0">Фичи</v-card-title>
                <v-card-text>
                  <v-checkbox
                    v-for="feature in license.features"
                    :key="feature.id"
                    v-model="feature.included"
                    :label="feature.name"
                    hide-details
                    disabled
                  ></v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6">
              <v-text-field
                label="Изменил"
                v-model="license.creatorName"
                disabled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                label="Дата последнего изменения"
                v-model="formatUpdateTime"
                disabled
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary darken-1"
          text
          @click="updateLicenseData"
          :disabled="!isValid"
          >Сохранить
        </v-btn>
      </v-card-actions>

      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>

    <v-dialog v-model="dateWarningDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Внимание</v-card-title>
        <v-card-text
          >Указанная дата окончания лицензии приходится на выходной
          день</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dateWarningDialog = false"
            >Продолжить</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sosSendDialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline"
          >Продление лицензий на 10 дней</v-card-title
        >
        <v-card-text
          ><b>Внимание!</b> Эта и остальные лицензии, созданные при помощи одной
          и той же Мастер-лицензии, в результате будут продлены. Эту операцию
          можно выполнить всего <b><u>один раз</u></b
          >. Продолжить?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="sosSendDialog = false"
            >Отмена</v-btn
          >
          <v-btn color="green darken-1" dark @click="sendSos">Да</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import API from "@/axios/api";
import FormatDateTime from "@/utils/time.js";

export default {
  name: "LicenseEdit",
  props: ["licenseId"],
  data() {
    return {
      loading: true,

      license: {
        features: [],
        licExpires: null,
      },
      choices: {},
      isValid: true,
      notEmptyRule: (v) => !!v || "Поле не может быть пустым",

      sosSendDialog: false,

      dateWarningDialog: false,
      date: null,
      dateMenu: false,
      masterExpiresFormatted: null,
    };
  },
  watch: {
    date() {
      this.license.licExpires = this.formatDate(this.date);
      if (
        new Date(this.date).getFullYear() < 2100 &&
        [6, 5].includes(new Date(this.date).getDay())
      ) {
        this.dateWarningDialog = true;
      }
    },
    "license.licExpires"() {
      this.date = this.parseDate(this.license.licExpires);
    },
  },
  methods: {
    getIsoDate(date) {
      return date.toISOString().substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    addDays(days) {
      let date = new Date();
      this.date = this.getIsoDate(
        new Date(date.setDate(date.getDate() + days))
      );
    },
    addMonths(months) {
      let date = new Date();
      let newDate = new Date(date.setMonth(date.getMonth() + months));
      let masterExpiresDate = new Date(this.license.masterExpires);
      if (newDate > masterExpiresDate)
        this.date = this.getIsoDate(masterExpiresDate);
      else this.date = this.getIsoDate(newDate);
    },
    setMaxDate() {
      this.license.licExpires = this.masterExpiresFormatted;
    },
    back() {
      history.back();
    },
    async getLicenseData() {
      await API.get(`licenses/${this.licenseId}`)
        .then((response) => {
          console.log(response.data);
          this.license = response.data.license;
          this.date = this.getIsoDate(new Date(this.license.licExpires));
          this.license.licExpires = this.formatDate(this.date);
          this.masterExpiresFormatted = this.formatDate(
            this.getIsoDate(new Date(this.license.masterExpires))
          );
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message)
            this.$store.commit("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
        });
    },
    sendSos() {
      this.sosSendDialog = false;
      API.get(`licenses/${this.licenseId}/sos`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("showSnackbar", {
            color: "success",
            text: "Лицензия продлена",
          });
          this.loading = true;
          this.getLicenseData().then(() => (this.loading = false));
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message)
            this.$store.dispatch("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
          else
            this.$store.dispatch("showSnackbar", {
              color: "error",
              text: "Лицензия не продлена",
            });
        });
    },
    updateLicenseData() {
      API.post(`licenses/${this.licenseId}`, this.license)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("showSnackbar", {
            color: "success",
            text: "Свойства Лицензии обновлены",
          });
          this.getLicenseData();
          this.$store.dispatch("updateLicenses");
        })
        .catch((error) => {
          this.$store.dispatch("showSnackbar", {
            color: "error",
            text: "Свойства Лицензии не обновлены",
          });
          console.log(error);
        });
    },
  },
  created() {
    this.loading = true;
    this.$store.commit("setCrumbs", [
      { text: "main", disabled: false, to: "/", exact: true },
      { text: "licenses", disabled: false, to: "/licenses", exact: true },
      { text: this.licenseId, disabled: true },
    ]);
    this.getLicenseData().then(() => (this.loading = false));
  },
  computed: {
    formattedObject() {
      return `${this.license.objectName} (${this.license.objectId})`
    },

    formatUpdateTime() {
      if (this.license.updateTime == null) return "";
      return FormatDateTime(this.license.updateTime);
    },
  },
};
</script>

<style>
.v-label--is-disabled {
  color: rgba(0, 0, 0, 0.6) !important;
}

.v-chip--disabled {
  opacity: 1 !important;
}

.v-input--checkbox .v-label--is-disabled {
  color: rgba(0, 0, 0, 1) !important;
}

input:disabled {
  color: rgba(0, 0, 0, 1) !important;
}
</style>